import { useState } from 'react';

import { IconLink } from '@iwoca/icons';
import { useParams } from 'react-router-dom';

import styles from './ShareLinkOpenBanking.module.css';
import { useGetOpenBankingActiveAccounts } from '../../api/lendingApi/lendingApiQueries';
import { useGetOpenBankingProviders } from '../../api/openBankingShareableLinkApi/useGetOpenBankingProviders';
import { usePostOpenBankingShareableLinkMutation } from '../../api/openBankingShareableLinkApi/usePostOpenBankingShareableLinkMutation';
import { useGetOpenBankingShareableLink } from '../../api/openBankingShareableLinkApi/useQueryOpenShareableLink';
import { Button } from '../Button/Button';
import { BankSelectionModal } from '../TradingHistory/OpenBanking/BankSelectionModal/BankSelectionModal';
import { TrueLayerDocumentRequirementContentUK } from '../TradingHistory/OpenBanking/LinkOpenBankingDocumentRequirementContent/TrueLayerDocumentRequirementContentUK';

export const ShareLinkOpenBanking = () => {
  const { token } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { openBankingLink, isLoading: isShareableLinkLoading } =
    useGetOpenBankingShareableLink({ token });
  const stateKey = openBankingLink?.state_key;

  const { bankList, isLoading: isProvidersLoading } =
    useGetOpenBankingProviders({
      stateKey,
      token,
    });

  const { notifyApplicant, isPending } =
    usePostOpenBankingShareableLinkMutation();
  const { activeAccounts } = useGetOpenBankingActiveAccounts({
    stateKey,
    token,
  });

  const isBankListReady =
    !isShareableLinkLoading && !isProvidersLoading && stateKey;

  const businessName = openBankingLink?.business_name;

  const handleLinkBankAccount = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFinishAndNotify = () => {
    if (token) {
      notifyApplicant({ token });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <h1 className={styles.title}>
          {businessName} needs your help to finish their loan application.
        </h1>
        <h2 className={styles.subTitle}>
          You have been requested to link their business bank account via our
          secure platform.
        </h2>
      </div>

      <p className={styles.description}>
        <strong>
          Link {businessName}’s business bank account using Open Banking
        </strong>
      </p>
      <div className={styles.truelayerRequirement}>
        <TrueLayerDocumentRequirementContentUK />
      </div>

      {activeAccounts?.accounts && activeAccounts.accounts.length > 0 && (
        <div data-testid="linked-accounts-list">
          {/* Linked Account List goes here */}
        </div>
      )}

      <div>
        <Button
          className={styles.button}
          onClick={handleLinkBankAccount}
          disabled={!isBankListReady}
        >
          Link bank account <IconLink />
        </Button>
      </div>

      <BankSelectionModal
        isOpen={isModalOpen}
        handleClose={handleCloseModal}
        bankList={bankList}
        shouldSkipPermissionView={false}
        stateKey={stateKey || ''}
        ableToShareLink={false}
        sharedLinkBusinessName={businessName}
      />

      {activeAccounts?.accounts && activeAccounts.accounts.length > 0 && (
        <div className={styles.finishSection}>
          <p className={styles.finishText}>
            All done and don’t need to link any more accounts?
          </p>
          <Button
            className={styles.finishButton}
            onClick={handleFinishAndNotify}
            disabled={isPending}
          >
            Finish and notify applicant
          </Button>
        </div>
      )}
    </div>
  );
};
